import React from 'react';
import styled from 'styled-components';


interface trowErrorProps{
    message:string
    locations:object[]
    path:string[]
    extensions:{
         code:string
         exception:{
              stacktrace:string[]
         }
    }
}

export  class trowError extends Error {
    constructor(listErrors:trowErrorProps[]) {
        super();
        
        this.name = 'GraphqlError';
        if(listErrors.length>0){
            let itemShow=listErrors[0];

            console.error('Error:',itemShow);

            switch(itemShow.extensions.code) { 
            case 'EMAIL_NOT_FOUND':
                this.message='El correo electrónico proporcionado no se encuentra registrado. Favor de crear una nueva cuenta, da click en <a href="/registro-atleti-id">"CREAR CUENTA"</a>.';
                break;
            case 'EMAIL_NOT_VALIDATE':
                this.message='Favor de concluir el proceso de registro , da click en <a href="/registro-atleti-id">"CREAR CUENTA"</a>.';  
                break;
            case 'PASSWORD_INCORRECT':
                this.message='El password es incorrecto';
                break; 
            case 'EMAIL_ALREADY_VALIDATED':
                this.message='La cuenta de email proporcionada ya ha sido validada';
                break;      
            case 'INVALID_CURP':
                this.message='El CURP es inválido.';
                break;  
            case 'EMAIL_NOT_REGISTER':
                this.message=`
                        El correo electrónico proporcionado no se encuentra registrado como titular de ningún Abono ADSL. 
                        Si crees que esto es un error, por favor ponte en contacto con nosotros vía email a:
                        <a href="mailto:abonados@atleticodesanluis.mx">abonados@atleticodesanluis.mx</a>
                         o vía Whatsapp, al <a href="https://api.whatsapp.com/send?phone=524441118872">444-111-8872</a>.
                    `;
                break;  
            case 'PROFILE_CODE_ERROR':
                this.message='El código introducido no es válido. Favor de revisar el correo electrónico enviado y capturar el código que ahí se muestra.';
                break;
            case 'GASTRONOMIC_GUIDE_CODE_NOT_FOUND':
                this.message = 'Código incorrecto.';
                break;
            case 'DAILY_POMO_CONCESSION_NOT_FOUND':
                this.message = 'Concecion no encontrada.';
                break;   
            case 'GASTRONOMIC_GUIDE_ID_INVALID':
                this.message = 'El QR no corresponde a este establecimiento.';
                break;                                                                                                                                   
            default:
                this.message=itemShow.message;
                break;
            }

            switch(this.message) {
            case 'Too many connections':
                this.message='Servidor ocupado, por favor Inténtelo de nuevo más tarde.';
                break;
            case 'Internal server error':
                this.message='Internal server error.';
                break;                    
            }

        }else{
            console.error('unknow error:',listErrors);
            this.message='unknow error';
        }
    }
}



interface props{
     errors:any
} 

const ShowErrosStyled= styled.div`
    padding: 16px 32px;
    border: 1px solid var(--color-danger);
    background-color: var(--color-danger-light);
    color: var(--color-danger);
    text-align: center;
    border-radius: 4px;
    margin-bottom: 2rem;
    line-height: 20px;
    a{
        color: var(--color-danger);
        font-weight:bold;
        text-decoration: underline;
        &:hover{text-decoration:none}
    }
`;

export default (props:props) => {
    console.error(props);
    return (
        <ShowErrosStyled>
            {props.errors.networkError?
                <>
                    <ol>
                        {props.errors.networkError.result.errors.map((Item:{code:string,message:string}) =>(
                            <li>{Item.message}</li>
                        ))}
                    </ol>
                </>
                :<div dangerouslySetInnerHTML={{__html: props.errors.message?props.errors.message:props.errors}} />
            }
        </ShowErrosStyled>
    );
}